<template>
    <div class="TotalBackgroundSettings">
        <h1>平台相关参数设置</h1>
        <div class="Usermanagementborder">
            <div class="title">
                <span style="margin-right:20px;">货物等级设置</span>
                <el-button icon="el-icon-plus" @click="addItem('grade')"></el-button>
            </div>
            <template v-for="(item, index) in formCargoGrade">
                <div class="content" :key="item.keyId">
                    <el-divider v-if="index > 0"></el-divider>
                    <el-form
                        :ref="`formCargoGrade${item.keyId}`"
                        label-width="80px"
                        :model="item"
                        :rules="rulesCargoGrade"
                    >
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="货物等级" prop="goodsClass">
                                    <el-col :span="20">
                                        <el-input v-model="item.goodsClass" placeholder="请输入"></el-input>
                                    </el-col>
                                </el-form-item>
                            </el-col>
                            <el-col :span="10">
                                <el-form-item label="重量范围" required>
                                    <el-col :span="8">
                                        <el-form-item prop="smallWeight">
                                            <el-input v-model="item.smallWeight" placeholder="请输入"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2" style="text-align:center;">kg</el-col>
                                    <el-col :span="2" style="text-align:center;">~</el-col>
                                    <el-col :span="8">
                                        <el-form-item prop="bigWeight">
                                            <el-input v-model="item.bigWeight" placeholder="请输入"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2" style="margin-left:10px;">kg</el-col>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="材积系数" prop="volumeValue">
                                    <el-col :span="14">
                                        <el-input v-model="item.volumeValue" placeholder="请输入"></el-input>
                                    </el-col>
                                    <el-col :span="8" style="margin-left:10px;">X1000</el-col>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="尺寸范围" required>
                            <el-col :span="10">
                                <el-col :span="7">
                                    <el-input v-model="item.smalls[0]" placeholder="请输入"></el-input>
                                </el-col>
                                <el-col :span="1" style="text-align:center;">X</el-col>
                                <el-col :span="7">
                                    <el-input v-model="item.smalls[1]" placeholder="请输入"></el-input>
                                </el-col>
                                <el-col :span="1" style="text-align:center;">X</el-col>
                                <el-col :span="8">
                                    <el-input v-model="item.smalls[2]" placeholder="请输入"></el-input>
                                </el-col>
                            </el-col>
                            <el-col :span="1" style="text-align:center;">~</el-col>
                            <el-col :span="10">
                                <el-col :span="7">
                                    <el-input v-model="item.bigs[0]" placeholder="请输入"></el-input>
                                </el-col>
                                <el-col :span="1" style="text-align:center;">X</el-col>
                                <el-col :span="7">
                                    <el-input v-model="item.bigs[1]" placeholder="请输入"></el-input>
                                </el-col>
                                <el-col :span="1" style="text-align:center;">X</el-col>
                                <el-col :span="8">
                                    <el-input v-model="item.bigs[2]" placeholder="请输入"></el-input>
                                </el-col>
                            </el-col>
                        </el-form-item>
                    </el-form>
                    <div style="float:right;margin-bottom:20px;">
                        <el-button
                            type="danger"
                            @click="delCargoGradeItem(item, index)"
                            v-if="formCargoGrade.length > 1"
                        >
                            删除
                        </el-button>
                        <el-button type="primary" @click="saveCargoGradeItem(`formCargoGrade${item.keyId}`, item)">
                            保存设置
                        </el-button>
                    </div>
                </div>
            </template>
        </div>
        <div class="Usermanagementborder">
            <div class="title">仓储费用</div>
            <div class="content">
                <el-form label-width="90px">
                    <el-form-item label="免费天数">
                        <el-col :span="4">
                            <el-input v-model="formSingle.freeDay"></el-input>
                        </el-col>
                        <el-col :span="2" style="margin-left:10px;">天</el-col>
                    </el-form-item>
                    <el-form-item label="计费重单价">
                        <el-col :span="4">
                            <el-input v-model="formSingle.billingUnitPrice"></el-input>
                        </el-col>
                        <el-col :span="2" style="margin-left:10px;">/天/kg</el-col>
                    </el-form-item>
                    <el-form-item label="操作费设置">
                        <div>重量范围计费</div>
                        <template v-for="(item, index) in formMany.operate">
                            <div :key="item.keyId" style="overflow:hidden;">
                                <el-col :span="2">
                                    <el-button
                                        icon="el-icon-plus"
                                        v-if="index === 0"
                                        @click="addItem('operate')"
                                    ></el-button>
                                    <el-button
                                        icon="el-icon-minus"
                                        v-else
                                        @click="delItem('operate', item, index,arri)"
                                    ></el-button>
                                </el-col>
                                <el-col :span="4">
                                    <el-input v-model="item.smallWeight"></el-input>
                                </el-col>
                                <el-col :span="1" style="text-align:center;">kg</el-col>
                                <el-col :span="1" style="text-align:center;">~</el-col>
                                <el-col :span="4">
                                    <el-input v-model="item.bigWeight"></el-input>
                                </el-col>
                                <el-col :span="1" style="text-align:center;">kg</el-col>
                                <el-col :span="4" :offset="1">
                                    <el-input v-model="item.priceValue"></el-input>
                                </el-col>
                                <el-col :span="1" style="text-align:center;">元</el-col>
                            </div>
                        </template>
                    </el-form-item>
                </el-form>
                <div style="float:right;margin-bottom:20px;">
                    <el-button type="primary" @click="saveStorage('storage')">保存设置</el-button>
                </div>
            </div>
        </div>
        <div class="Usermanagementborder">
            <div class="title">物流费用</div>
            <div class="content">
                <el-form label-width="100px">
                    <el-form-item label="平台费用">
                        <el-collapse v-model="activeName" accordion>
                            <el-collapse-item :title="arri" :name="indexs" v-for="(arri, indexs) in dulizhanarr" :key="indexs">
                                <div>
                                    <template v-for="(item, index) in dulizhanobj.wu[arri]">
                                        <div :key="item.keyId" style="overflow:hidden;margin-top:5px;">
                                            <el-col :span="3">
                                                <label>物流预扣费用</label>
                                            </el-col>
                                            <el-col :span="2">
                                                <el-button
                                                    icon="el-icon-plus"
                                                    v-if="index === 0"
                                                    @click="addItem('logistics',item,arri)"
                                                ></el-button>
                                                <el-button
                                                    icon="el-icon-minus"
                                                    v-else
                                                    @click="delItem('logistics', item, index,arri)"
                                                ></el-button>
                                            </el-col>
                                            <el-col :span="4">
                                                <el-select v-model="item.priceName" filterable placeholder="请选择" @change="select(arri)">
                                                    <el-option
                                                        v-for="key in logisticsList"
                                                        :key="key.id"
                                                        :label="key.itemTypeName"
                                                        :value="key.itemTypeName"
                                                    ></el-option>
                                                </el-select>
                                                <!-- <el-input v-model=""></el-input> -->
                                            </el-col>
                                            <el-col :span="4" :offset="1">
                                                <el-input v-model="item.priceValue" @input="select(arri)"></el-input>
                                            </el-col>
                                            <el-col :span="1" style="margin-left:10px;">元</el-col>
                                        </div>
                                    </template>
                                </div>
                                <div style="margin-top:25px;">
                                    <template v-for="(item1, index1) in dulizhanobj.bag[arri]">
                                        <div :key="item1.keyId" style="overflow:hidden;margin-top:5px;">
                                            <el-col :span="3">
                                                <label>包材费用</label>
                                            </el-col>
                                            <el-col :span="2">
                                                <el-button
                                                    icon="el-icon-plus"
                                                    v-if="index1 === 0"
                                                    @click="addItem('bag',item1,arri)"
                                                ></el-button>
                                                <el-button
                                                    icon="el-icon-minus"
                                                    v-else
                                                    @click="delItem('bag', item1, index1,arri)"
                                                ></el-button>
                                            </el-col>
                                            <el-col :span="4">
                                                <el-input v-model="item1.priceName" @input="select(arri)"></el-input>
                                            </el-col>
                                            <el-col :span="4" :offset="1">
                                                <el-input v-model="item1.priceValue" @input="select(arri)"></el-input>
                                            </el-col>
                                            <el-col :span="1" style="margin-left:10px;">元</el-col>
                                        </div>
                                    </template>
                                </div>
                                 
                            </el-collapse-item>
                           
                        </el-collapse>
                        <!-- <template v-for="(item, index) in formMany.logistics">
                            <div :key="item.keyId" style="overflow:hidden;">
                                <el-col :span="2">
                                    <el-button
                                        icon="el-icon-plus"
                                        v-if="index === 0"
                                        @click="addItem('logistics')"
                                    ></el-button>
                                    <el-button
                                        icon="el-icon-minus"
                                        v-else
                                        @click="delItem('logistics', item, index)"
                                    ></el-button>
                                </el-col>
                                <el-col :span="4">
                                    <el-select v-model="item.priceName" filterable placeholder="请选择">
                                        <el-option
                                            v-for="key in logisticsList"
                                            :key="key.id"
                                            :label="key.itemTypeName"
                                            :value="key.itemTypeName"
                                        ></el-option>
                                    </el-select>
                                     <el-input v-model=""></el-input> 
                                 </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-input v-model="item.priceValue"></el-input>
                                </el-col>
                                <el-col :span="1" style="margin-left:10px;">元</el-col>
                            </div>
                        </template> --> 
                    </el-form-item>
                    <el-form-item label="分装费用">
                        <el-col :span="4">
                            <el-input v-model="formSingle.packPrice"></el-input>
                        </el-col>
                        <el-col :span="2" style="margin-left:10px;">/元/件</el-col>
                    </el-form-item>
                    <el-form-item label="合装费用">
                        <el-col :span="4">
                            <el-input v-model="formSingle.integratePrice"></el-input>
                        </el-col>
                        <el-col :span="2" style="margin-left:10px;">/元/件</el-col>
                    </el-form-item>
                    <!-- <el-form-item label="包材费用">
                        <el-collapse v-model="activeName" accordion>
                            <el-collapse-item :title="arra" :name="indexss" v-for="(arra, indexss) in dulizhanarr" :key="indexss">
                               
                            </el-collapse-item>
                        </el-collapse>
                    </el-form-item> -->
                </el-form>
                <div style="float:right;margin-bottom:20px;">
                    <el-button type="primary" @click="saveStorage('logistics')">保存设置</el-button>
                </div>
            </div>
        </div>
        <div class="Usermanagementborder">
            <div class="title">运营参数设置</div>
            <div class="content">
                <el-form label-width="100px">
                    <el-form-item label="订单汇率调整">
                        <el-col :span="2">数值</el-col>
                        <el-col :span="4">
                            <el-input v-model="formSingle.orderRate"></el-input>
                        </el-col>
                        <el-col :span="1" style="margin-left:10px;">元</el-col>
                        <el-col :span="2" :offset="1">百分比</el-col>
                        <el-col :span="4">
                            <el-input v-model="formSingle.orderRatePercentage"></el-input>
                        </el-col>
                        <el-col :span="1" style="margin-left:10px;">%</el-col>
                    </el-form-item>
                    <el-form-item label="连连汇率调整">
                        <el-col :span="2">数值</el-col>
                        <el-col :span="4">
                            <el-input v-model="formSingle.lianRate"></el-input>
                        </el-col>
                        <el-col :span="1" style="margin-left:10px;">元</el-col>
                        <el-col :span="2" :offset="1">百分比</el-col>
                        <el-col :span="4">
                            <el-input v-model="formSingle.lianRatePercentage"></el-input>
                        </el-col>
                        <el-col :span="1" style="margin-left:10px;">%</el-col>
                    </el-form-item>
                </el-form>
                <div style="float:right;margin-bottom:20px;">
                    <el-button type="primary" @click="saveStorage('operate')">保存设置</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "TotalBackgroundSettings copy",
    data() {
        const checkGoodsClass = (rule, value, callback) => {
            const reg = /^[A-Z]*$/g;
            if (!reg.test(value)) {
                return callback(new Error("必须为大写字母"));
            }
            callback();
        };
        return {
            activeName: '1',
            UserInfo: {},
            formCargoGrade: [
                {
                    keyId: "custom0",
                    goodsClass: "",
                    smalls: ["", "", ""],
                    bigs: ["", "", ""],
                    smallWeight: "",
                    bigWeight: "",
                    volumeValue: "",
                },
            ],
            formSingle: {
                freeDay: "",
                billingUnitPrice: "",
                packPrice: "",
                orderRate: "",
                orderRatePercentage: "",
                lianRate: "",
                lianRatePercentage: "",
                integratePrice: "",
            },
            formMany: {
                operate: [],
                logistics: [],
                bag: [],
            },
            rulesCargoGrade: {
                goodsClass: [
                    { required: true, message: "请输入货物等级", trigger: "blur" },
                    { validator: checkGoodsClass, trigger: "blur" },
                ],
                smallWeight: [{ required: true, message: "重量范围输入有误", trigger: "blur" }],
                bigWeight: [{ required: true, message: "重量范围输入有误", trigger: "blur" }],
                volumeValue: [{ required: true, message: "材积系数输入有误", trigger: "blur" }],
            },
            logisticsList: [],
            //独立站数组
            dulizhanarr:[],
            //独立站分类对象
            dulizhanobj:{
                
            }
        };
    },
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        this.getLogistics();
        this.getPageData();
    },
    methods: {
        select(item){
            this.dulizhanarr.push(item);
            this.dulizhanarr=Array.from(new Set(this.dulizhanarr));
        },
        formManyInit() {
            if (this.formMany.operate.length === 0) {
                this.formMany.operate.push({
                    keyId: 0,
                    priceValue: null,
                    smallWeight: null,
                    bigWeight: null,
                    priceType: 1,
                    companyId: this.UserInfo.company_id,
                });
            }
            for(var i=0;i<this.dulizhanobj.wu.length;i++){
                if (this.dulizhanobj.wu[i].length === 0) {
                    this.dulizhanobj.wu[i].push({
                        keyId: 0,
                        priceName: null,
                        priceValue: null,
                        priceType: 2,
                        companyId: this.UserInfo.company_id,
                    });
                }
            }
            for(var a=0;a<this.dulizhanobj.bag.length;a++){
                if (this.dulizhanobj.bag[a].length === 0) {
                    this.dulizhanobj.bag[a].push({
                        keyId: 0,
                        priceName: null,
                        priceValue: null,
                        priceType: 3,
                        companyId: this.UserInfo.company_id,
                    });
                }
            }
            
        },
        addItem(type,index,arri) {
            let itemType = "";
            let itemObj = {};
            const operation = {
                grade: () => {
                    itemType = "formCargoGrade";
                    itemObj = {
                        keyId: "custom" + this.formCargoGrade.length + 1,
                        goodsClass: "",
                        smalls: ["", "", ""],
                        bigs: ["", "", ""],
                        smallWeight: "",
                        bigWeight: "",
                        volumeValue: "",
                    };
                },
                operate: () => {
                    itemType = "operate";
                    itemObj = {
                        keyId: this.formMany.operate.length + 1,
                        priceValue: null,
                        smallWeight: null,
                        bigWeight: null,
                        priceType: 1,
                        companyId: this.UserInfo.company_id,
                    };
                },
                logistics: () => {
                    itemType = "logistics";
                    itemObj = {
                        companyId: this.UserInfo.company_id,
                        keyId: this.dulizhanobj.wu[arri].length,
                        priceName: null,
                        priceType: 2,
                        priceValue: null,
                        sellerType:index.sellerType,
                    };
                },
                bag: () => {
                    itemType = "bag";
                    itemObj = {
                        keyId: this.dulizhanobj.bag[arri].length ,
                        priceName: null,
                        priceValue: null,
                        priceType: 3,
                        companyId: this.UserInfo.company_id,
                        sellerType:index.sellerType,
                    };
                },
            };
            operation[type]();
            if (!itemType) return;
            // type === "grade" ?  : this[itemForm][itemType].push(itemObj);
            if(type==="grade"){
                this[itemType].push(itemObj)
            }else if(type==="operate"){
                this[itemType].push(itemObj)
            }else if(type==="logistics"){
                this.dulizhanobj.wu[arri].push(itemObj);
                this.dulizhanarr.push(index.sellerTypeName);
                this.dulizhanarr=Array.from(new Set(this.dulizhanarr));
            }else if(type==="bag"){
                this.dulizhanobj.bag[arri].push(itemObj);
                 this.dulizhanarr.push(index.sellerTypeName);
                this.dulizhanarr=Array.from(new Set(this.dulizhanarr));
            }
            this.$nextTick(()=>{
                console.log(this.dulizhanobj.wu,this.dulizhanobj.bag)
            })
            console.log(this.dulizhanobj.bag,this.dulizhanobj.wu)
        },
        delItem(type, item, index,arri) {
            if (!type && !index) return;
            if (!item.id) {
                if(type==="logistics"){
                    this.dulizhanobj.wu[arri].splice(index, 1);
                    this.dulizhanarr.push(arri);
                    this.dulizhanarr=Array.from(new Set(this.dulizhanarr));
                }else if(type==="bag"){
                    this.dulizhanobj.bag[arri].splice(index, 1);
                    this.dulizhanarr.push(arri);
                    this.dulizhanarr=Array.from(new Set(this.dulizhanarr));
                }
                // this.dulizhanobj[type].splice(index, 1);
            } else {
                this.$confirm("您确定要删除这条数据吗？", "提示").then(() => {
                    const API = Baseurl + "priceSettingController/deletePriceSetting";
                    const paramsData = {
                        id: item.id,
                    };
                    ajaxPost(API, paramsData).then(res => {
                        const { code, data } = res.data;
                        if (code === 200) {
                            this.getPageData();
                            this.$message.success("操作成功");
                        }
                    });
                });
            }
        },
        delCargoGradeItem(item, index) {
            if (!item.id) {
                this.formCargoGrade.splice(index, 1);
                return;
            }
            const handelRequest = () => {
                const API = Baseurl + "goodsClassController/deleteGoodsClass";
                const paramsData = {
                    id: item.id,
                };
                ajaxPost(API, paramsData).then(res => {
                    const { code, data } = res.data;
                    if (code === 200) {
                        this.getPageData();
                        this.$message.success("操作成功");
                    }
                });
            };
            this.$confirm("是否确认删除", "提示").then(() => {
                handelRequest();
            });
        },
        getLogistics() {
            const API = Baseurl + "purchaseController/selectItemList";
            const paramsData = {
                itemCode: "HYXUN0000006",
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.logisticsList = data;
                }
            });
        },
        getPageData() {
            const API = Baseurl + "logisticsController/getBackstageSetting";
            const paramsData = {
                companyId: this.UserInfo.company_id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    const { goodsClasses, systemSetting, priceSettings } = data;
                    if (goodsClasses.length) {
                        goodsClasses.forEach(item => item.keyId === item.id);
                        this.formCargoGrade = goodsClasses;
                    }
                    if (systemSetting) {
                        this.formSingle = systemSetting;
                    }
                    if (priceSettings.length) {
                        this.formMany.operate = [];
                        this.formMany.logistics = [];
                        this.formMany.bag = [];
                        priceSettings.forEach(item => {
                            item.keyId = item.id;
                            if (item.priceType === 1) {
                                this.formMany.operate.unshift(item);
                            } else if (item.priceType === 2) {
                                this.formMany.logistics.unshift(item);
                            } else if (item.priceType === 3) {
                                this.formMany.bag.unshift(item);
                            }
                            if(item.sellerTypeName===null){

                            }else{
                                this.dulizhanarr.push(item.sellerTypeName);
                            }
                            
                        });
                        this.dulizhanarr=Array.from(new Set(this.dulizhanarr));
                        console.log(this.dulizhanarr);
                        this.dulizhanobj['bag']={};
                        this.dulizhanobj['wu']={};
                        this.dulizhanarr.forEach(arri => {
                            this.dulizhanobj.wu[arri]=[];
                            this.dulizhanobj.bag[arri]=[];
                        });
                        for(var i=0;i<priceSettings.length;i++){
                            if(priceSettings[i].sellerType===1){
                                if(priceSettings[i].priceType===2){
                                    this.dulizhanobj.wu[this.dulizhanarr[0]].push(priceSettings[i]);
                                }else{
                                    this.dulizhanobj.bag[this.dulizhanarr[0]].push(priceSettings[i]);
                                }
                            }else if(priceSettings[i].sellerType===2){
                                if(priceSettings[i].priceType===2){
                                    this.dulizhanobj.wu[this.dulizhanarr[1]].push(priceSettings[i]);
                                }else{
                                    this.dulizhanobj.bag[this.dulizhanarr[1]].push(priceSettings[i]);
                                }
                            }else if(priceSettings[i].sellerType===3){
                                if(priceSettings[i].priceType===2){
                                    this.dulizhanobj.wu[this.dulizhanarr[2]].push(priceSettings[i]);
                                }else{
                                    this.dulizhanobj.bag[this.dulizhanarr[2]].push(priceSettings[i]);
                                }
                            }else if(priceSettings[i].sellerType===4){
                                if(priceSettings[i].priceType===2){
                                    this.dulizhanobj.wu[this.dulizhanarr[3]].push(priceSettings[i]);
                                }else{
                                    this.dulizhanobj.bag[this.dulizhanarr[3]].push(priceSettings[i]);
                                }
                            }else if(priceSettings[i].sellerType===5){
                                if(priceSettings[i].priceType===2){
                                    this.dulizhanobj.wu[this.dulizhanarr[4]].push(priceSettings[i]);
                                }else{
                                    this.dulizhanobj.bag[this.dulizhanarr[4]].push(priceSettings[i]);
                                }
                            }else if(priceSettings[i].sellerType===6){
                                if(priceSettings[i].priceType===2){
                                    this.dulizhanobj.wu[this.dulizhanarr[5]].push(priceSettings[i]);
                                }else{
                                    this.dulizhanobj.bag[this.dulizhanarr[5]].push(priceSettings[i]);
                                }
                            }else if(priceSettings[i].sellerType===7){
                                if(priceSettings[i].priceType===2){
                                    this.dulizhanobj.wu[this.dulizhanarr[6]].push(priceSettings[i]);
                                }else{
                                    this.dulizhanobj.bag[this.dulizhanarr[6]].push(priceSettings[i]);
                                }
                            }
                            // this.dulizhanobj..push(priceSettings[i])
                        }
                        console.log(this.dulizhanobj);
                    }
                    this.formManyInit();
                }
            });
        },
        saveCargoGradeItem(formName, item = {}) {
            if (!Object.keys(item).length) return;
            const itemData = JSON.parse(JSON.stringify(item));
            const handelRequest = () => {
                // for (const key in itemData) {
                //     const item = itemData[key];
                //     const numberList = ["smallWeight", "bigWeight", "volumeValue", "smalls", "bigs"];
                //     if (numberList.includes(key)) {
                //         if (key === "smalls" || key === "bigs") {
                //             for (const value of item) {
                //                 if (!value && value !== 0) {
                //                     this.$message.warning("请输入尺寸范围");
                //                     return;
                //                 } else if (isNaN(Number(value))) {
                //                     this.$message.warning("输入的尺寸范围不合法");
                //                     return;
                //                 }
                //             }
                //         } else {
                //             if (isNaN(Number(item))) {
                //                 this.$message.warning(`${item}输入有误，只能输入数值`);
                //                 return;
                //             }
                //         }
                //     }
                // }
                // if (Number(itemData.bigWeight) <= Number(itemData.smallWeight)) {
                //     this.$message.warning("重量范围输入有误");
                //     return;
                // }
                const API = Baseurl + "goodsClassController/updateGoodsClass";
                itemData.smalls = itemData.smalls.sort();
                itemData.bigs = itemData.bigs.sort();
                delete itemData.keyId;
                const paramsData = {
                    companyId: this.UserInfo.company_id,
                    ...itemData,
                };
                ajaxPost(API, paramsData).then(res => {
                    const { code, data } = res.data;
                    if (code === 200) {
                        this.getPageData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error(data);
                    }
                });
            };
            this.$refs[formName][0].validate(valid => {
                if (valid) {
                    handelRequest();
                }
            });
        },
        saveStorage(type) {
            // 1.操作费用  2.物流预扣费用  3.包材费用
            let priceType = 0;
            const that=this;
            const rulesValidate = {
                storage: () => {
                    const value1 = Number(that.formSingle.freeDay);
                    const value2 = Number(that.formSingle.billingUnitPrice);
                    if (!value1) {
                        that.$message.warning("免费天数输入有误");
                        return false;
                    }
                    if (!value2) {
                        that.$message.warning("计费重单价输入有误");
                        return false;
                    }
                    const validateArr = that.formMany.operate;
                    for (const item of validateArr) {
                        const value1 = Number(item.smallWeight);
                        const value2 = Number(item.bigWeight);
                        const value3 = Number(item.priceValue);
                        if (!value1 || !value2 || value2 < value1) {
                            that.$message.warning("重量范围输入有误");
                            return;
                        }
                        if (!value3) {
                            that.$message.warning("重量范围计费输入有误");
                            return;
                        }
                    }
                    return true;
                },
                logistics: () => {
                    // const value1 = Number(this.formSingle.packPrice);
                    // if (!value1) {
                    //     this.$message.warning("分装费用输入有误");
                    //     return;
                    // }
                    const validateArr1 = that.dulizhanobj.wu;
                    const validateArr2 = that.dulizhanobj.bag;
                    for(var i=0;i<that.dulizhanarr.length;i++){
                        for (const item of validateArr1[that.dulizhanarr[i]]) {
                            if (!item.priceName) {
                                that.$message.warning("物流预扣费用名称输入有误");
                                return;
                            }
                            const value1 = Number(item.priceValue);
                            if (!value1) {
                                that.$message.warning("物流预扣费用输入有误");
                                return;
                            }
                        }
                        for (const item of validateArr2[that.dulizhanarr[i]]) {
                            if (!item.priceName) {
                                that.$message.warning("包材费用名称输入有误");
                                return;
                            }
                            const value1 = Number(item.priceValue);
                            if (!value1) {
                                that.$message.warning("包材费用输入有误");
                                return;
                            }
                        }
                    }
                    // return true;
                },
                operate: () => {
                    // const value1 = Number(this.formSingle.orderRate);
                    // const value2 = Number(this.formSingle.orderRatePercentage);
                    // const value3 = Number(this.formSingle.lianRate);
                    // const value4 = Number(this.formSingle.lianRatePercentage);
                    // if (!value1) {
                    //     this.$message.warning("订单汇率数值输入有误");
                    //     return;
                    // }
                    // if (!value2) {
                    //     this.$message.warning("订单汇率百分比输入有误");
                    //     return;
                    // }
                    // if (!value3) {
                    //     this.$message.warning("连连汇率数值输入有误");
                    //     return;
                    // }
                    // if (!value4) {
                    //     this.$message.warning("连连汇率百分比输入有误");
                    //     return;
                    // }
                    return true;
                },
            };
            // const resultValidate = rulesValidate[type]();
            // if (!resultValidate) return;
            const handelRequest1 = () => {
                const API = Baseurl + "systemSettingController/settingSystemSetting";
                const paramsData = {
                    companyId: that.UserInfo.company_id,
                    ...that.formSingle,
                };
                return new Promise((resolve, reject) => {
                    ajaxPost(API, paramsData).then(res => {
                        const { code, data } = res.data;
                        if (code === 200) {
                            resolve();
                        } else {
                            reject();
                        }
                    });
                });
            };
            const handelRequest2 = () => {
                const API = Baseurl + "priceSettingController/updatePriceSetting";
                let priceSettings = [];
                if (type === "storage") {
                    priceSettings = [...that.formMany.operate];
                } else {
                     for(var i=0;i<that.dulizhanarr.length;i++){
                         for(var a=0;a<that.dulizhanobj.wu[that.dulizhanarr[i]].length;a++){
                            priceSettings.push(that.dulizhanobj.wu[that.dulizhanarr[i]][a]);
                         }
                         for(var a=0;a<that.dulizhanobj.bag[that.dulizhanarr[i]].length;a++){
                            priceSettings.push(that.dulizhanobj.bag[that.dulizhanarr[i]][a]);
                         }
                     }
                }
                console.log(priceSettings)
                const paramsData = { priceSettings };
                return new Promise((resolve, reject) => {
                    ajaxPost(API, paramsData).then(res => {
                        const { code, data } = res.data;
                        if (code === 200) {
                            resolve();
                        } else {
                            reject();
                        }
                    });
                });
            };
            const requestResult = Promise.all([handelRequest1(), handelRequest2()]);
            requestResult
                .then(res => {
                    that.getPageData();
                    that.$message.success("操作成功");
                })
                .catch(() => {
                    that.getPageData();
                    that.$message.warning("操作有误");
                });
        },
    },
};
</script>

<style lang="scss" scopd>
.TotalBackgroundSettings {
    width: 98%;
    overflow: hidden;
    .Usermanagementborder {
        border-radius: 5px;
        width: 60%;
        border: 1px #eee solid;
        overflow: hidden;
    }
    .title {
        padding-left: 8px;
        background: #eee;
        font-size: 16px;
        line-height: 40px;
        color: #828080;
    }
    .content {
        padding: 20px;
    }
}
</style>
